import { Layout, Typography } from 'antd';

const { Footer: AntFooter } = Layout;
const { Text } = Typography;

export default function Footer() {
  return (
    <AntFooter className="flex  justify-between items-center !p-2  flex-wrap gap-2">
      <Text type="secondary" className="text-xs">
        © 2026 42Kicks Admin Portal. All rights reserved.
      </Text>
    </AntFooter>
  );
}
